import type { ToolDefinition } from "../types";
import compressPdfTool from "./compress-pdf";
import imageToPdfTool from "./image-to-pdf";
import pdfToImageTool from "./pdf-to-image";
import extractPdfImagesTool from "./extract-pdf-images";
import pdfDpiCheckerTool from "./pdf-dpi-checker";
import pdfDpiChangerTool from "./pdf-dpi-changer";

export const pdfTools: ToolDefinition[] = [
  compressPdfTool,
  imageToPdfTool,
  pdfToImageTool,
  extractPdfImagesTool,
  pdfDpiCheckerTool,
  pdfDpiChangerTool,
];

export { default as compressPdfTool } from "./compress-pdf";
export { default as imageToPdfTool } from "./image-to-pdf";
export { default as pdfToImageTool } from "./pdf-to-image";
export { default as extractPdfImagesTool } from "./extract-pdf-images";
export { default as pdfDpiCheckerTool } from "./pdf-dpi-checker";
export { default as pdfDpiChangerTool } from "./pdf-dpi-changer";
